module.exports = __webpack_public_path__ + "static/img/4.2dbbef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-vida/4.png
// module id = n/EO
// module chunks = 0